"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTable = require("@tanstack/react-table");
var _BaseColumn = require("./support/BaseColumn");
var _BaseButton = _interopRequireDefault(require("../../../../components/controls/buttons/BaseButton"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Cell = require("../cell/Cell.styled");
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var _components = require("../../../../components");
var _jsxRuntime = require("react/jsx-runtime");
var Button = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "ButtonColumn__Button",
  componentId: "sc-1v3e42e-0"
})(["background-color:transparent;color:", ";min-width:66px;", ";& :not(.fixed-colors) > svg{path{fill:", ";}}&:hover,&.focus-ring{background-color:", ";color:", ";& :not(.fixed-colors) > svg{path{fill:", ";}}}"], _tokens.default.sky.sys.color.text.content.primary, _tokens.default.sky.comp.button.font.standard, _tokens.default.sky.sys.color.text.content.primary, _tokens.default.sky.sys.color.background.neutral['1'], _tokens.default.sky.sys.color.text.content.primary, _tokens.default.sky.sys.color.text.content.primary);
var ButtonColumn = function ButtonColumn(_) {
  return null;
};
var columnHelper = (0, _reactTable.createColumnHelper)();
ButtonColumn.toColumnDef = function (child) {
  var _child$props = child.props,
    header = _child$props.header,
    button = _child$props.button,
    align = _child$props.align;
  return columnHelper.display(_objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props, undefined, true), {
    id: header,
    cell: function cell(_ref) {
      var row = _ref.row;
      var properties = row.getIsGrouped() ? undefined : button(row.original);
      if (properties) {
        var label = properties.label,
          tooltip = properties.tooltip,
          icon = properties.icon,
          onClick = properties.onClick,
          disabled = properties.disabled,
          disabledTooltip = properties.disabledTooltip;
        if (!label) {
          return null;
        }
        var buttonElement = /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
          noMargin: true,
          leftIcon: icon,
          onClick: onClick,
          children: label
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.StyledCell, {
          align: align,
          narrow: true,
          children: disabled ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Text, {
              size: '1',
              color: 'medium',
              children: label
            }), disabledTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconTooltip, {
              icon: 'help',
              children: disabledTooltip
            })]
          }) : tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Tooltip, {
            interactable: false,
            content: tooltip,
            width: _components.Tooltip.WIDTH.l,
            children: buttonElement
          }) : buttonElement
        });
      }
      return null;
    }
  }));
};
var _default = exports.default = ButtonColumn;